// // // import React, { useState } from "react";
// // // import Button from "../Button/Button";
// // // import "./Header.css";

// // // const Header = () => {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);

// // //   const navLinks = [
// // //     { label: "Home", href: "#home" },
// // //     { label: "Services", href: "#services" },
// // //     { label: "What We Do", href: "#what-we-do" },
// // //     { label: "Why We're Best", href: "#why-us" },
// // //     { label: "Team", href: "#team" },
// // //   ];

// // //   const toggleMenu = () => {
// // //     setIsMenuOpen(!isMenuOpen);
// // //   };

// // //   const handleNavClick = () => {
// // //     setIsMenuOpen(false);
// // //   };

// // //   return (
// // //     <header className="header">
// // //       <div className="container">
// // //         <nav className="navbar">
// // //           <div className="logo">
// // //             <span className="logo-text">inTax</span>
// // //           </div>

// // //           <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
// // //             {navLinks.map((link) => (
// // //               <a
// // //                 key={link.label}
// // //                 href={link.href}
// // //                 className="nav-link"
// // //                 onClick={handleNavClick}
// // //               >
// // //                 {link.label}
// // //               </a>
// // //             ))}
// // //             <Button
// // //               type="primary"
// // //               size="sm"
// // //               text="Book Appointment"
// // //               className="nav-cta"
// // //               onClick={() => alert("Booking appointment...")}
// // //             />
// // //           </div>

// // //           <div className="mobile-menu-btn" onClick={toggleMenu}>
// // //             <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
// // //           </div>
// // //         </nav>
// // //       </div>
// // //     </header>
// // //   );
// // // };

// // // export default Header;

// // import React, { useState } from "react";
// // import Button from "../Button/Button";
// // import "./Header.css";
// // import logo from "../../images/HNULogo.png"; // your PNG logo

// // const Header = () => {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);

// //   const navLinks = [
// //     { label: "Home", href: "#home" },
// //     { label: "Services", href: "#services" },
// //     { label: "About Us", href: "#about-us" },
// //     { label: "Why We're Best", href: "#why-us" },
// //     // { label: "Team", href: "#team" },
// //   ];

// //   const toggleMenu = () => {
// //     setIsMenuOpen(!isMenuOpen);
// //   };

// //   const handleNavClick = () => {
// //     setIsMenuOpen(false);
// //   };

// //   return (
// //     <header className="header">
// //       <div className="container">
// //         <nav className="navbar">
// //           {/* LEFT - CTA */}
// //           <div className="nav-left">
// //             <Button
// //               type="primary"
// //               size="sm"
// //               text="Book Appointment"
// //               className="nav-cta"
// //               onClick={() => alert("Booking appointment is coming...")}
// //             />
// //           </div>

// //           {/* CENTER - NAVIGATION */}
// //           <div className={`nav-center ${isMenuOpen ? "active" : ""}`}>
// //             {navLinks.map((link) => (
// //               <a
// //                 key={link.label}
// //                 href={link.href}
// //                 className="nav-link"
// //                 onClick={handleNavClick}
// //               >
// //                 {link.label}
// //               </a>
// //             ))}
// //           </div>

// //           {/* RIGHT - LOGO */}
// //           <div className="nav-right">
// //             <img src={logo} alt="Company Logo" className="logo-img" />
// //           </div>

// //           {/* MOBILE MENU BUTTON */}
// //           <div className="mobile-menu-btn" onClick={toggleMenu}>
// //             <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
// //           </div>
// //         </nav>
// //       </div>
// //     </header>
// //   );
// // };

// // export default Header;

// import React, { useState } from "react";
// import Button from "../Button/Button";
// import BookingModal from "../BookingModal/BookingModal";
// import "./Header.css";
// import logo from "../../images/hnupic.png";

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const navLinks = [
//     { label: "Home", href: "#home" },
//     { label: "Services", href: "#services" },
//     { label: "About Us", href: "#about-us" },
//     { label: "Packages", href: "#packages" },
//     // { label: "Why We're Best", href: "#why-us" },
//   ];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleNavClick = () => {
//     setIsMenuOpen(false);
//   };

//   const openModal = () => {
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <>
//       <header className="header">
//         <div className="container">
//           <nav className="navbar">
//             {/* LEFT - CTA */}
//             <div className="nav-left">
//               {/* <Button
//                 type="primary"
//                 size="sm"
//                 text="Book Appointment"
//                 className="nav-cta"
//                 onClick={openModal}
//               /> */}

//               <img src={logo} alt="Company Logo" className="logo-img" />
//             </div>

//             {/* CENTER - NAVIGATION */}
//             <div className={`nav-center ${isMenuOpen ? "active" : ""}`}>
//               {navLinks.map((link) => (
//                 <a
//                   key={link.label}
//                   href={link.href}
//                   className="nav-link"
//                   onClick={handleNavClick}
//                 >
//                   {link.label}
//                 </a>
//               ))}
//             </div>

//             {/* RIGHT - LOGO */}
//             <div className="nav-right">
//               <Button
//                 type="primary"
//                 size="sm"
//                 text="Book Appointment"
//                 className="nav-cta"
//                 onClick={openModal}
//               />
//               {/* <img src={logo} alt="Company Logo" className="logo-img" /> */}
//             </div>

//             {/* MOBILE MENU BUTTON */}
//             <div className="mobile-menu-btn" onClick={toggleMenu}>
//               <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
//             </div>
//           </nav>
//         </div>
//       </header>

//       <BookingModal isOpen={isModalOpen} onClose={closeModal} />
//     </>
//   );
// };

// export default Header;

import React, { useState } from "react";
import Button from "../Button/Button";
import BookingModal from "../BookingModal/BookingModal";
import "./Header.css";
import logo from "../../images/hnupic.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navLinks = [
    { label: "Home", href: "#home" },
    { label: "Services", href: "#services" },
    { label: "About Us", href: "#about-us" },
    { label: "Packages", href: "#packages" },
    // { label: "Why We're Best", href: "#why-us" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <nav className="navbar">
            {/* LEFT - LOGO */}
            <div className="nav-left">
              <img src={logo} alt="Company Logo" className="logo-img" />
            </div>

            {/* CENTER - NAVIGATION */}
            <div className={`nav-center ${isMenuOpen ? "active" : ""}`}>
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="nav-link"
                  onClick={handleNavClick}
                >
                  {link.label}
                </a>
              ))}
            </div>

            {/* RIGHT - BOOK APPOINTMENT BUTTON */}
            <div className="nav-right">
              <Button
                type="primary"
                size="sm"
                text="Book Appointment"
                className="nav-cta"
                onClick={openModal}
              />
            </div>

            {/* MOBILE MENU BUTTON */}
            <div className="mobile-menu-btn" onClick={toggleMenu}>
              <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
            </div>
          </nav>
        </div>
      </header>

      <BookingModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Header;
